export default __webpack_public_path__ + "static/media/Liang-Fang_Chao.a59d4ac2.jpg";